import { colors } from '../../colors';
var fiftyFiftyCard = {
  bgColorLight: colors.white,
  bgColorDark: colors.black,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default fiftyFiftyCard;